import React from 'react'
import DatePicker from 'react-datepicker'

export const InputTypeText = ({ label, type, name, placeholder,required, errorMessage, dispatch, stateData, colSize, isReadOnly }) => {
  return (
    <div className={colSize =="auto" ?`col-auto mb-2` :`col-md-${colSize}  mb-2`}>
      
            <div className="form-group">
        <label htmlFor="" className="form-lbl">
          {label} {required && <span className="must-field">*</span>}
        </label>
        <input
          type={type}
          value={stateData?.[name]}
          name={name}
          id={name}
          onChange={(e) => dispatch({ type: "input", payload: e.target })}
          readOnly={isReadOnly}
          className={`form-control form-g1`}
          placeholder={placeholder}
        />
        {errorMessage ? (
          <div
            className="error error-message"
            style={{ color: "red" }}
          >
            {errorMessage}
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  )
}
export const InputTypeDate = ({ label, type, name, placeholder,required, errorMessage, dispatch, stateData, colSize, isReadOnly }) => {
  return (
    <div className={colSize =="auto" ?`col-auto mb-2` :`col-md-${colSize}  mb-2`}>
      
            {/* <div className="form-group"> */}
        {/* <label htmlFor="" className="form-lbl">
          {label} {required && <span className="must-field">*</span>}
        </label>
        <input
          type={type}
          value={stateData?.[name]}
          name={name}
          id={name}
          onChange={(e) => dispatch({ type: "input", payload: e.target })}
          readOnly={isReadOnly}
          className={`form-control form-g1`}
          placeholder={placeholder}
        />
        {errorMessage ? (
          <div
            className="error error-message"
            style={{ color: "red" }}
          >
            {errorMessage}
          </div>
        ) : (
          ""
        )} */}
      {/* </div> */}

     
                        <div className="form-group">
                        <label htmlFor="" className="form-lbl">
          {label} {required && <span className="must-field">*</span>}
        </label>

                          <DatePicker
                            selected={stateData?.[name]}
                            onChange={(date) =>
                            { 
                              dispatch({type:"input", payload: {value:date,name:name,type:""}})
                            }
                            }
                            value={stateData?.[name]}
                            required
                            className="form-control form-g1"
                          />

{errorMessage ? (
          <div
            className="error error-message"
            style={{ color: "red" }}
          >
            {errorMessage}
          </div>
        ) : (
          ""
        )}
                        </div>
                      
    </div>
  )
}
export const InputBlank = ({  colSize }) => {
 
  return (
    <div className={`col-${colSize} mb-2`}>
      
            <div className="form-group">
      
          
      </div>
    </div>
  )
}

export const InputTypeTextarea = ({ label, name, placeholder, dispatch, stateData, colSize, isReadOnly }) => {
  return (
    <div className={`col-md-${colSize} mb-2`}>
      <div className="form-group">
        <label htmlFor="" className="form-lbl">
          {label}<span className="must-field">*</span>
        </label>

        <textarea
          rows="5"
          value={stateData?.[name]}
          name={name}
          id={name}
          onChange={(e) => dispatch({ type: "input", payload: e.target })}
                    readOnly={isReadOnly}


          className={`form-control form-g1 message-area`}
          placeholder={placeholder}
        />
      </div>

    </div>
  )
}

export const InputTypeSelect = ({required, label, name, placeholder, errorMessage, dispatch, stateData, colSize, optionsList, optionName, isReadOnly }) => {

  return (
    <div className={`col-md-${colSize} mb-2`}>
      <div className="form-group">
        <label htmlFor="" className="form-lbl">
        {label} {required && <span className="must-field">*</span>}

        </label>
        <select
          value={stateData?.[name]}
          name={name}
          id={name}
                    readOnly={isReadOnly}


          onChange={(e) => dispatch({ type: "input", payload: e.target })}
          className={`form-control form-g1`}
          placeholder={placeholder}
        >
          <option value="">Choose {label}</option>
          {
            optionsList?.map((items, i) => {
              return (
                <option key={i} value={items.id}>
                  {items[optionName]}
                </option>
              );
            })

          }
        </select>

        {errorMessage ? (
          <div
            className="error error-message"
            style={{ color: "red" }}
          >
            {errorMessage}
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  )
}
export const InputTypeCheckbox = ({ isChecked,label, name, placeholder, errorMessage, dispatch, stateData, colSize, optionsList, optionName, isReadOnly }) => {


  return (
    <div className={colSize =="auto" ?`col-auto mb-2` :`col-md-${colSize}  mb-2`}>


      <label
        key={1}
        htmlFor="unit_category"
        className="form-check-btn"
      >
        <input
          type="checkbox"
          value={stateData?.[name]}
                    readOnly={isReadOnly}

checked={isChecked}
          name={name}
          id={name}
          onChange={(e) => dispatch({ type: "input", payload: e.target })}
        // name={choice.id}
        // value={choice.id}
        // key={index}
        // disabled={
        //   designation !== "Owner" &&
        //   designation !== "Partner"
        // }
        // checked={unitcategoryStatus?.includes(choice.id)}
        // onChange={(event) => unitCategoryFunc(event)}
        />
        {label}
        <span className="checkmark"></span>
      </label>


    </div>
  )
}






